import { render } from "./EditarModeloEtapa.vue?vue&type=template&id=1575b90b"
import script from "./EditarModeloEtapa.vue?vue&type=script&lang=js"
export * from "./EditarModeloEtapa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__